/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Fal_TitleInputs */

const en_admin_settings_groups_fal_title = /** @type {(inputs: Admin_Settings_Groups_Fal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fal`)
};

const zh_admin_settings_groups_fal_title = /** @type {(inputs: Admin_Settings_Groups_Fal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fal`)
};

/**
* | output |
* | --- |
* | "Fal" |
*
* @param {Admin_Settings_Groups_Fal_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_fal_title = /** @type {((inputs?: Admin_Settings_Groups_Fal_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Fal_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_fal_title(inputs)
	return zh_admin_settings_groups_fal_title(inputs)
});
export { admin_settings_groups_fal_title as "admin.settings.groups.fal.title" }